var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveGeozoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 3.33333H15.8333M4.16667 16.6667H15.8333M16.6667 4.16667V15.8333M3.33333 4.16667V15.8333M15.8333 4.16667H17.5V2.5H15.8333V4.16667ZM9.16667 10.8333H10.8333V9.16667H9.16667V10.8333ZM2.5 4.16667H4.16667V2.5H2.5V4.16667ZM15.8333 17.5H17.5V15.8333H15.8333V17.5ZM2.5 17.5H4.16667V15.8333H2.5V17.5Z",
    stroke: "#00E2D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveGeozoneIcon);
export default __webpack_public_path__ + "static/media/active-geozone-icon.3caf77e9b6169d79aac9db20f72f0a55.svg";
export { ForwardRef as ReactComponent };